import type { DevelopmentStatus } from '@/shared/utils/format-status.js';

export type TabIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const ALL_TABS: TabIndex[] = [0, 1, 2, 3, 4, 5, 6, 7];

// Nomes de status alinhados a DEVELOPMENT_STATUSES (development-contract.ts) — os nomes usados aqui antes
// (EF_DEVOLVIDA, AGUARDANDO_INICIO_DEV, AGUARDANDO_VALIDACAO_DOC, EM_VALIDACAO_DOC, AGUARDANDO_LIBERACAO_UC, EM_VALIDACAO_UC)
// não existem no enum real e sempre caíam no `default`, causando exibição de abas em excesso
// porque bloqueava a aba de Solicitações: SOLICITATION_ALLOWED_STATUSES no backend inclui EM_DESENVOLVIMENTO/AGUARDANDO_REVISAO_DOCUMENTACAO,
// que antes não mostravam a aba 5).
// `status` é tipado como DevelopmentStatus (não string) justamente para que um `case` com nome errado, como os
// do bug histórico acima, quebre a compilação em vez de cair silenciosamente no `default`. Import de `shared/`,
// não de `infra/contracts` — presentation não pode depender de infra (ADR-002). O `default` permanece como
// rede de segurança em runtime (ex.: valor vindo de fora do type-checker), ainda que hoje o switch já cubra
// os 16 membros do tipo.
// O segundo parâmetro governa só a visibilidade da aba — não a ação de registrar início, que é
// checada dentro da própria seção.
export function getVisibleTabs(status: DevelopmentStatus, canViewDevelopmentTab: boolean): TabIndex[] {
    switch (status) {
        case 'EF_EM_ELABORACAO':
        case 'EF_REJEITADA_IA':
        case 'EF_EM_VALIDACAO_IA':
            return [0, 1, 6];
        case 'EF_VALIDADA_IA':
        case 'AGUARDANDO_ATRIBUICAO_TECNICA':
        case 'EM_ANALISE_TECNICA':
        case 'AGUARDANDO_APROVACAO_ESTIMATIVA':
        case 'ESTIMATIVA_EM_REVISAO':
            return [0, 1, 2, 6];
        case 'AGUARDANDO_INICIO':
            return canViewDevelopmentTab ? [0, 1, 2, 7, 3, 6] : [0, 1, 2, 3, 6];
        case 'EM_DESENVOLVIMENTO':
        case 'IMPEDIDO':
            return canViewDevelopmentTab ? [0, 1, 2, 7, 3, 5, 6] : [0, 1, 2, 3, 5, 6];
        case 'AGUARDANDO_REVISAO_DOCUMENTACAO':
            return canViewDevelopmentTab ? [0, 1, 2, 7, 3, 4, 5, 6] : [0, 1, 2, 3, 4, 5, 6];
        case 'EM_VALIDACAO_CONSULTOR':
        case 'EM_VALIDACAO_USUARIO_CHAVE':
        case 'COM_SOLICITACOES_PENDENTES':
            return canViewDevelopmentTab ? [0, 1, 2, 7, 3, 4, 5, 6] : [0, 1, 2, 3, 4, 5, 6];
        case 'ENCERRADO':
        case 'CANCELADO':
            return [0, 1, 2, 3, 4, 5, 6];
        default:
            return ALL_TABS;
    }
}
